import React, { useState, useEffect } from 'react'
import {
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import rotas from '../../services/rotas'
import rest from '../../lib/rest'
import useCentralLojas from '../../lib/useCentralLojas'

const CentralLojas = ({ refresh }) => {

  const [lojas, setLojas] = useState([])

  const listaLojas = () => {
    const retorno = rest.get(rotas.lojas)
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null){
        let lista = ret.lista
        setLojas(lista)
        if (!sessionStorage.getItem('filial_id')) {
          sessionStorage.setItem('filial_id', lista[0].filial_id)
          sessionStorage.setItem('loja', lista[0].fantasia)
          refresh(lista[0].filial_id)
        }
      }
    })

    return true
  }

  useEffect(() => {
    listaLojas()
  },[])

  const lojaClick = (e) =>{
    let filial_id = e.target.id,
        loja = e.currentTarget.textContent
    useCentralLojas.setCentralLoja(filial_id, loja)
    refresh(filial_id)
  }

  return (
    <Col>
        <UncontrolledDropdown direction="left" group className="float-right">
        <DropdownToggle caret color="secondary" className="m-0 btn-central">
          {useCentralLojas.centralLoja().loja}
        </DropdownToggle>
        <DropdownMenu className="dropMenu">
            <DropdownItem header className="dropHeader">Selecione a Loja</DropdownItem>
            <DropdownItem divider />
            {lojas.map(item => <DropdownItem key={item.filial_id} id={item.filial_id} onClick={lojaClick}>{item.fantasia}</DropdownItem>)}
        </DropdownMenu>
        </UncontrolledDropdown>
    </Col>
  )

}

export default CentralLojas
